<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%"
  >
    <div class="record">
      <div class="record_title mb_18 fs_20 text_center bold">返利点明细</div>
      <div class="record_subtitle flex_a_b">
        <div class="record_label fs_18 flex_1" style="width: 0">累计获得返利点</div>
        <div class="record_detail flex_a_b">
          <div class="record_get fs_30 bold">{{ pointFixed2 }}</div>
          <div class="record_upper fs_18">/{{ limitPoint }}</div>
        </div>
      </div>
      <div class="record_list">
        <van-empty
          v-if="noRecord"
          class="custom-image"
          image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
          description="暂无数据"
        />
        <van-list
          v-model="vloading"
          :finished="finished"
          :finished-text="noRecord ? '': '没有更多了'"
          offset="24"
          @load="onLoadList"
        >
        <div
          v-for="(it, idx) in recordInfo.list"
          :key="it.id"
          class="record_item flex_center mt_16"
          :class="{ mt_1: idx === 0 }"
        >
          <div class="record_left flex_1 fs_15" style="width: 0">
            <div class="record_money mb_8">
              <template v-if="it.type === 1">
                实付金额{{ it.money }}元
              </template>
              <template v-else>
                兑换{{ it.content }}
              </template>
            </div>
            <div class="record_time" style="color: #454545">{{ it.createdAt }}</div>
          </div>
          <div class="record_right">
            <div
              class="record_reward fs_15 mb_4"
              :style="{
                color: it.type === 1 ? '#FF4605' : '#454545',
                textAlign: 'right',
              }"
            >
              {{ it.type === 1 ? '+' : '' }}{{ it.point || 0 }}返利点
            </div>
            <div :class="{ visible_hiden: it.pointType === 1 }" class="record_tip fs_9" style="text-align: right;">返利已达上限</div>
          </div>
        </div>
        </van-list>
        
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Empty, List } from 'vant';
import { getRegisterRebateRecord } from '@/apis/btBoxActivity'

const SIZE_PER_PAGE = 10
export default {
  props: {
    activityId: {
      type: [String, Number],
      default: '',
    },
    placeId: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [List.name]: List,
  },
  data () {
    return {
      visible: false,
      limitPoint: 0,
      recordInfo: {
        list: [],
        currentPage: 1,
      },
      noRecord: false,
      totalPoint: 0,
      finished: false,
      vloading: false,
    }
  },
  watch: {
    visible (f) {
      !f && this.$emit('close')
    },
  },
  computed: {
    pointFixed2 () {
      return this.totalPoint.toFixed(2)
    },
  },
  methods: {
    triggerVisible (visible) {
      this.visible = visible;
      if (visible) {
        this.recordInfo.list = []
        this.recordInfo.currentPage = 1
        this.finished = false
        this.onLoadList()
      }
    },
    onLoadList () {
      if (!this.visible) return
      this.getList(this.recordInfo.currentPage || 1);
    },
    getList (page = 1) {
      this.vloading = true
      getRegisterRebateRecord({
        activityId: this.activityId,
        placeId: this.placeId,
        size: SIZE_PER_PAGE,
        page,
      }).then(res => {
        const { list, currentPage, point, totalPoint, limitPoint } = res.data || {}
        this.recordInfo = {
          ...this.recordInfo,
          currentPage: currentPage + 1,
          list: this.recordInfo.list.concat(list),
        }
        // 累计返利
        this.totalPoint = totalPoint
        this.limitPoint = limitPoint
        this.noRecord = !this.recordInfo.list.length
        this.finished = list.length < SIZE_PER_PAGE
      }).finally(() => {
        this.vloading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.record {
  height: 100%;
  padding: 26px 24px 16px;
  color: #000;
  .record_list {
    max-height: 280px;
    overflow: auto;
  }
  .record_subtitle {
    padding: 8px 4px 8px 12px;
    border-bottom: 1px solid #ededed;
    margin-bottom: 12px;
  }
}
</style>
